import React from 'react';

const MyTIOrgCharts = () => {
  return <div>OrgCharts</div>;
};

export default MyTIOrgCharts;
